// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
//import libs
import 'slick-carousel/slick/slick.min';
import '../src/assets/lib/flickity/js/flickity.pkgd.min';
import 'jquery-parallax-scroll/js/jquery.parallax-scroll';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import 'aos/dist/aos';
import 'jquery-lazy/jquery.lazy.min';
import 'jquery-lazy/jquery.lazy.plugins.min';
// require main js file
require('@js/index');
require('@js/header');
require('@js/video-bg');
require('@js/sliders');
require('@js/modals');
require('@js/select');
require('@js/accordion');
require('@js/cursor');
require('@js/load-more');
require('@js/ajax');
require('@js/ajax-members');
require('@js/animations');
require('@js/social-bar');
require('@js/timezone');
require('@js/hs-scroll');
require('@js/filtering');
require('@js/application-forms');
require('@js/has-class');